var map = {
	"./template.bet575": 2164,
	"./template.bet575.tsx": 2164,
	"./template.bet777": 2165,
	"./template.bet777.tsx": 2165,
	"./template.betgalaxy": 2166,
	"./template.betgalaxy.tsx": 2166,
	"./template.betprofessor": 2167,
	"./template.betprofessor.tsx": 2167,
	"./template.betroyale": 2168,
	"./template.betroyale.tsx": 2168,
	"./template.betstride": 2169,
	"./template.betstride.tsx": 2169,
	"./template.buffalobet": 2170,
	"./template.buffalobet.tsx": 2170,
	"./template.chromabet": 2171,
	"./template.chromabet.tsx": 2171,
	"./template.default": 674,
	"./template.default.tsx": 674,
	"./template.epicodds": 1631,
	"./template.epicodds.tsx": 1631,
	"./template.fiestabet": 2172,
	"./template.fiestabet.tsx": 2172,
	"./template.forsport": 1632,
	"./template.forsport.tsx": 1632,
	"./template.gigabet": 2173,
	"./template.gigabet.tsx": 2173,
	"./template.goldenbet888": 2174,
	"./template.goldenbet888.tsx": 2174,
	"./template.goldenrush": 2175,
	"./template.goldenrush.tsx": 2175,
	"./template.hyperbet": 2176,
	"./template.hyperbet.tsx": 2176,
	"./template.juicybet": 2177,
	"./template.juicybet.tsx": 2177,
	"./template.junglebet": 2178,
	"./template.junglebet.tsx": 2178,
	"./template.magnumbet": 2179,
	"./template.magnumbet.tsx": 2179,
	"./template.oldgill": 2180,
	"./template.oldgill.tsx": 2180,
	"./template.puntcity": 2181,
	"./template.puntcity.tsx": 2181,
	"./template.puntgenie": 2182,
	"./template.puntgenie.tsx": 2182,
	"./template.pyramidbet": 2183,
	"./template.pyramidbet.tsx": 2183,
	"./template.questbet": 2184,
	"./template.questbet.tsx": 2184,
	"./template.slambet": 2185,
	"./template.slambet.tsx": 2185,
	"./template.sterlingparker": 2186,
	"./template.sterlingparker.tsx": 2186,
	"./template.sugarcastle": 2187,
	"./template.sugarcastle.tsx": 2187,
	"./template.templebet": 2188,
	"./template.templebet.tsx": 2188,
	"./template.titanbet": 2189,
	"./template.titanbet.tsx": 2189,
	"./template.ts": 987,
	"./template.vikingbet": 2190,
	"./template.vikingbet.tsx": 2190,
	"./template.volcanobet": 2191,
	"./template.volcanobet.tsx": 2191,
	"./template.wellbet": 2192,
	"./template.wellbet.tsx": 2192
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2468;